import { TURN_BY_TURN_DIRECTION, TURN_BY_TURN_TYPE } from '../../enums/model.enums';
import { Location } from '../location';
/**
 * class {TurnByTurnInstruction}
 * Used to provide a list of single turn by turn navigation instructions for transitions between connections etc.
 */
export class TurnByTurnInstruction {
    constructor(type, direction, distanceInMeters, timeInSeconds, startPosition) {
        this._type = type;
        this._direction = direction;
        this._distanceInMeters = distanceInMeters;
        this._timeInSeconds = timeInSeconds;
        this._startPosition = startPosition;
    }
    /**
     * Factory method to create an instance of this class without
     * having to correctly fill the constructor.
     * !!! You should always use this instead of the constructor !!!
     * @param values
     * @returns {TurnByTurnInstruction}
     */
    static factory(values) {
        const sanitizedValues = {};
        sanitizedValues.type = values.type !== undefined ? values.type : TURN_BY_TURN_TYPE.UNKNOWN;
        sanitizedValues.direction = values.direction !== undefined ? values.direction : TURN_BY_TURN_DIRECTION.UNKNOWN;
        sanitizedValues.distanceInMeters = values.distanceInMeters !== undefined ? values.distanceInMeters : 0;
        sanitizedValues.timeInSeconds = values.timeInSeconds !== undefined ? values.timeInSeconds : 0;
        sanitizedValues.startPosition = values.startPosition !== undefined ? Location.factory(values.startPosition) : Location.factory({});
        return new TurnByTurnInstruction(sanitizedValues.type, sanitizedValues.direction, sanitizedValues.distanceInMeters, sanitizedValues.timeInSeconds, sanitizedValues.startPosition);
    }
    /**
     * gets the internal type of the operation
     * @returns {TURN_BY_TURN_TYPE}
     */
    get type() {
        return this._type;
    }
    /**
     * sets the internal type of the operation
     * @param value
     */
    set type(value) {
        this._type = value;
    }
    /**
     * gets the internal direction of the operation
     * @returns {TURN_BY_TURN_DIRECTION}
     */
    get direction() {
        return this._direction;
    }
    /**
     * sets the internal direction of the operation
     * @param value
     */
    set direction(value) {
        this._direction = value;
    }
    /**
     * gets the distance of this instruction in the navigation
     * @returns {number}
     */
    get distanceInMeters() {
        return this._distanceInMeters;
    }
    /**
     * sets the distance of this instruction in the navigation
     * @param value
     */
    set distanceInMeters(value) {
        this._distanceInMeters = value;
    }
    /**
     * gets the duration of this instruction in the navigation
     * @returns {number}
     */
    get timeInSeconds() {
        return this._timeInSeconds;
    }
    /**
     * sets the duration of this instruction in the navigation
     * @param value
     */
    set timeInSeconds(value) {
        this._timeInSeconds = value;
    }
    /**
     * gets the starting position on the map as a Location object
     * @returns {Location}
     */
    get startPosition() {
        return this._startPosition;
    }
    /**
     * sets the starting position on the map as a Location object
     * @param value
     */
    set startPosition(value) {
        this._startPosition = value;
    }
}
//# sourceMappingURL=turnByTurnInstruction.js.map